import type { Identity } from './types';
import { getGuestIdentity } from './guest';
import { getCurrentIdentity } from './auth';
import { setActiveUserId } from './active-user';

/**
 * Store reactivo de identidad (M4.2).
 * Su única responsabilidad es mantener sincronizado el `activeUserId`
 * con la sesión de Supabase Auth, y exponer el estado a la UI.
 */
class IdentityState {
  identity = $state<Identity>(getGuestIdentity());
  ready = $state<boolean>(false);

  get isAuthenticated(): boolean {
    return this.identity.kind === 'authenticated';
  }

  get isGuest(): boolean {
    return this.identity.kind === 'guest';
  }

  get userId(): string {
    return this.identity.userId;
  }

  get email(): string | null {
    return this.identity.email ?? null;
  }

  get displayName(): string | null {
    return this.identity.displayName ?? null;
  }

  apply(id: Identity): void {
    this.identity = id;
    setActiveUserId(id.userId);
    this.ready = true;
  }

  async refresh(): Promise<void> {
    const id = await getCurrentIdentity();
    this.apply(id);
  }
}

export const identity = new IdentityState();